export const YMM_OPEN_EVENT = 'sxm:ymm:open';

export function requestYmmModal(): void {
    window.dispatchEvent(new CustomEvent(YMM_OPEN_EVENT));
}
